export function isWithinAllowedHours(start: number, end: number) {
	const currentHour = new Date().getHours();

	return currentHour >= start && currentHour < end;
}
